<div class="container" data-cy="agreements_page">
  <page-title [showArrow]="false" text="AGREEMENTS_SIGN_TITLE" (backChange)="navigateToMyBooking()"></page-title>
  <agreement-sign *ngIf="booking" [booking]="booking"></agreement-sign>
</div>
